export enum RoleClaimKey {
	Activity_Approve = 'Activity_Approve',
	Activity_Verify = 'Activity_Verify',
	FormDefinition_UseKioskMode = 'FormDefinition_UseKioskMode',
	Timecard_Read = 'Timecard_Read',
	TimeRecord_Approve = 'TimeRecord_Approve',
	TimeRecord_Lock = 'TimeRecord_Lock',
	TimeRecord_Verify = 'TimeRecord_Verify'
}